import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Spinner from 'components/Spinner/desktop';
import SVG from 'components/SVG';
import Modal from 'components/ModalProvider/Modal/Modal';

import crossSVG from '../../../img/cross.svg';
import promotionSVG from '../../../img/promotion.svg';
import './AgentPromotion.scss';
import Button from 'components/Button';
import useLinks from 'features/AgentFeedback/model/useLinks';
import Input from 'components/Input';

const b = block('agent-promotion-desktop');

const AgentPromotion = () => {
  const locale = useSelector(state => state.locale.locale);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const model = useLinks();

  if ((typeof model.state.links?.promociones?.is_visible === 'undefined' ? false : !model.state.links?.promociones?.is_visible)) return null;

  return (
    <section>
      <div className={b('base')} onClick={() => setIsModalVisible(true)}>
        <SVG className={b('icon')} svgProps={{ svg: promotionSVG }} />
        {locale.addPromotionLink}
      </div>
      {isModalVisible && (
        <Modal
          style={{ top: '25%', transform: 'translateX(-50%)' }}
          closeFunction={() => setIsModalVisible(false)}
          content={
            <form className={b('modal')} onSubmit={(e) => model.handleFormSubmit(e, 'promociones')}>
              <div className={b('modal-header')}>
                {locale.addPromotionLink}
                <SVG className={b('modal-cross')} svgProps={{ svg: crossSVG }} onClick={() => setIsModalVisible(false)} />
              </div>

              <div className={b('input')}>
                <Input
                  value={model.state.links?.['promociones']?.link}
                  onChange={e => model.onChangeLink('promociones', e.target.value)}
                  placeholder={locale.link}
                />
              </div>

              <div className={b('button')}>
                <Button disabled={model.actionProcessing} type="submit">{model.actionProcessing ? locale.processing : locale.save}</Button>
              </div>
            </form>}
        />
      )}
    </section>
  );
};

export default AgentPromotion;